import { Component } from 'react';
import { compose } from 'react-apollo';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import md5 from 'md5';
import { APP_SECRET, APP_KEY } from './../../constants/PaymentApi';
import { BASE_URL } from '../../constants/Common';

class Scoin extends Component {
    constructor() {
        super()
        this.state = {
            scoin: 0,
            dayBonus: 0
        }
    }

    generateUrl(user_info) {
        let checksum = md5(APP_SECRET + user_info.email);
        let url = ''
        url += 'email=' + user_info.email;
        url += '&';
        url += 'def_price=0';
        url += '&';
        url += 'checksum=' + checksum;
        url += '&';
        url += 'sitekey=' + APP_KEY;
        url += '&';
        url += 'returnurl=' + BASE_URL;
        return url;
    }

    render() {
        let { user_info } = this.props;
        if (JSON.stringify(user_info) === '{}') {
            return 'Loadding...';
        }

        return (
            window.location.replace('https://payment.vietid.net/Payment?' + this.generateUrl(user_info))
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default compose()(connect(mapStateToProps, null)(Scoin));


// WEBPACK FOOTER //
// ./src/components/Scoin/Scoin.js